import {
  createValidation,
  validatorMaxLength,
  validatorRequired,
} from '../../utils/formValidators';
import { luGeneralFormFields } from '../../constants/loadingUnit';

export default createValidation([
  {
    name: luGeneralFormFields.NAME,
    validators: [
      (field) => validatorRequired()(field),
      (field) => validatorMaxLength(40)(field),
    ],
  },
  {
    name: luGeneralFormFields.POWER,
    validators: [
      (field) => validatorRequired()(field),
      (field) => validatorMaxLength(40)(field),
    ],
  },
  {
    name: luGeneralFormFields.UNIT_MODEL,
    validators: (field) => validatorRequired()(field),
  },
]);
